import React from "react";
import clock from "../../assets/icons/clock.svg";
import { differenceInCalendarDays } from "date-fns";
import { getFullDate } from "./dateHelpers";

const CLOCK_ICON = (
  <span style={{ marginRight: 5 }}>
    <img src={clock} style={{ width: 17, height: 14 }} alt="clock" />
  </span>
);

export function getJobExpiringStatus({ date, show = true, showClock = true }) {
  let days = 0;
  if (show) {
    days = differenceInCalendarDays(date, new Date());
  }

  if (!show) {
    return (
      <>
        {showClock && CLOCK_ICON}
        <span style={{ paddingRight: 75 }}>Expires in </span>
      </>
    );
  } else if (days > 1) {
    return (
      <>
        {showClock && CLOCK_ICON}
        <span>Expires in </span>
        <span>{days} days</span>
      </>
    );
  } else if (days === 1) {
    return (
      <>
        {showClock && CLOCK_ICON}
        <span>Expires in </span>
        <span>{days} day</span>
      </>
    );
  } else if (days === 0) {
    return (
      <>
        {showClock && CLOCK_ICON}
        <span>Expires today</span>
      </>
    );
  } else {
    return (
      <>
        {showClock && CLOCK_ICON}
        <span>Expired: {getFullDate(date || new Date())}</span>
      </>
    );
  }
}
